import { ActivatedRoute } from '@angular/router';
import { BaseDataService, QueryParameter, ModalService, BaseCommonComponent, UserService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function digitsOnlyValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  return /^\d+$/.test(value) ? null : { digitsOnly: true };}

@Component({
  selector: 'yt-kpo-obrazac',
  templateUrl: './kpo-obrazac.component.html' 
})

export class KpoObrazacComponent 
extends BaseCommonComponent
implements OnInit {

   constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected userService: UserService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }
  

  ngOnInit() {
    
    super.ngOnInit();
    
    this.baseFormGroup = new FormGroup ({
      Godina: new FormControl(new Date().getFullYear())
    })

    this.addValidatorToFc('Godina',Validators.required, 'required','KPOOBRAZAC.GODINA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Godina',Validators.min(2020), 'min','KPOOBRAZAC.GODINA.VALIDATION.MIN');
    this.addValidatorToFc('Godina', digitsOnlyValidator, 'digitsOnly', 'KPOOBRAZAC.GODINA.VALIDATION.DIGITSONLY');
      
  }

}

